import { render } from "./PetChecklist.vue?vue&type=template&id=99980bfa&scoped=true"
import script from "./PetChecklist.vue?vue&type=script&lang=js"
export * from "./PetChecklist.vue?vue&type=script&lang=js"

import "./PetChecklist.vue?vue&type=style&index=0&id=99980bfa&scoped=true&lang=css"

import exportComponent from "/builds/sites/smolke/app-kwispelcoach-com/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-99980bfa"]])

export default __exports__